import { makeRequest } from 'utils/requestLogger';

export default (mode) => {
  const query = mode ? `?mode=${mode}` : '';
  return makeRequest('get', `/api/courses${query}`);
};



// WEBPACK FOOTER //
// ./src/app/services/courses/fetchCourseList.js